module.exports = __webpack_public_path__ + "img/mycars.f45b815b.png";